import { useQuery } from "@tanstack/react-query";
import { AxiosError } from "axios";

import { useEnvironment } from "@/common/contexts/EnvironmentContext";
import api from "@/common/utils/api";
import { ErrorResponse } from "@reflag/shared/api";
import { Dependee, UIFilter } from "@reflag/shared/filter";
import { FilterCheckDetails } from "@reflag/shared/filterAPI";

import { commonQueryKeys } from "./commonQueryKeys";

export function useFilterCheck(dependee?: Dependee, filter?: UIFilter) {
  const { appId } = useEnvironment();

  return useQuery<
    FilterCheckDetails,
    AxiosError<ErrorResponse>,
    FilterCheckDetails
  >({
    queryKey: commonQueryKeys.filterCheck(appId, dependee, filter),
    queryFn: () =>
      api
        .post<"/apps/:appId/filters/check">(
          `/apps/${appId}/filters/check`,
          { filter },
          {
            params: {
              segmentId: dependee?.type === "segment" ? dependee.id : undefined,
              featureId: dependee?.type === "feature" ? dependee.id : undefined,
            },
          },
        )
        .then((res) => res.data),
    enabled: !!appId && !!dependee?.id,
  });
}

export function useCanDeleteSegment(segmentId?: string) {
  const { data, ...rest } = useFilterCheck(
    segmentId ? { type: "segment", id: segmentId } : undefined,
  );

  return {
    ...rest,
    canDelete: data?.features.length === 0 && data?.segments.length === 0,
  };
}

export function useCanDeleteFeature(featureId?: string) {
  const { data, ...rest } = useFilterCheck(
    featureId ? { type: "feature", id: featureId } : undefined,
  );

  return {
    ...rest,
    canDelete: data?.features.length === 0 && data?.segments.length === 0,
  };
}
